module.exports = __webpack_public_path__ + "img/popuarticle.f15e1cc0.svg";